import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-b1-list',
  templateUrl: './b1-list.component.html',
  styleUrl: './b1-list.component.css'
})
export class B1ListComponent implements OnInit {
  displayedColumns: string[] = [
    'clientName', 'contactPerson', 'district', 'tehsil', 'village',
    'area', 'entryDate', 'category', 'mineral', 'fileStatus',
    'torOnlineDate', 'proposalNo', 'caseNo', 'pptStatus',
    'seiaaMinutes', 'ecStatus', 'nextFollowUp','action'
  ];

  dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  ngOnInit() {
    this.dataSource.data = this.generateDummyData(30);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }
    filterByStatus(status: any) {
    this.dataSource.filterPredicate = (data, filter) =>
      !filter || data.kycStatus.toLowerCase() === filter;
    this.dataSource.filter = status.toLowerCase();
  }

  generateDummyData(count: number) {
    return Array.from({ length: count }).map((_, i) => ({
      clientName: `Client ${i + 1}`,
      contactPerson: `Person ${i + 1}`,
      contactNo: `99999999${i}`,
      district: 'Bhopal',
      tehsil: 'Huzur',
      village: `Village ${i + 1}`,
      khasraNo: `KH-${i + 1}`,
      area: Math.floor(Math.random() * 10 + 1),
      entryDate: '2025-08-01',
      category: i % 2 === 0 ? 'B1' : 'B2',
      ecMp: 'EC Fresh',
      leaseValidity: '2025-2030',
      mpPlanPeriod: '5 years',
      blasting: i % 2 === 0 ? 'Blasting' : 'Non Blast',
      mineral: 'M-Sand',
      fileStatus: 'Running',
      filePreparedBy: 'Shivam',
      productionDetails: '1000 ton/year',
      torOnlineDate: '04.09.23',
      proposalNo: `P${1000 + i}`,
      caseNo: `2995/${23 + i}`,
      torSeacAgendaDate: '05.08.25',
      pptStatus: 'Recommended',
      torSeacMinutes: 'Approved',
      seiaaAgendaDate: '07.08.25',
      pptApproved: 'ADS Approved',
      seiaaMinutes: 'Accepted',
      remark: 'All Good',
      torGranted: 'Received',
      dd: 'Submitted',
      draftEia: 'Submitted',
      reportSent: 'Submitted',
      phDate: '05.09.25',
      newspaper: 'Published',
      ecStatus: i % 2 === 0 ? 'Granted' : 'Pending',
      hyperlinkFolder: 'http://example.com',
      kni: 'Note',
      finalEc: 'Done',
      currentStatus: 'Ongoing',
      presentStatus: 'SDM sign pending',
      nextFollowUp: '2025-09-10'
    }));
  }
}
